import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

const PostSummary = ({ post, profile, users, auth }) => {
    
    

    return (
        <div className="post-summary">
            <div className="card feed-card">
                <div className="card-header" style={styleHeader}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-between align-items-center">
                            <li className="btn btn-info rounded-circle">
                                {post.companyName[0] + post.companyName[1]} 
                            </li>
                            <div className="ml-2">
                                <div className="h5 m-0">{post.title}</div>
                                <div className="h7 text-muted">Posted by {<Link to={'/users/' + post.authorId} key={post.id} > {post.ceoNAME}</Link>}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <p className="card-text">{post.content}</p>
                    {post.avatarURL && <img src={post.avatarURL} alt="uploaded" style={imgStyle} />}
                    <hr />
                    <p className="grey-text m-0">{moment(post.createdAt.toDate()).calendar()}</p>
                </div>
            </div>
        </div>
    )
};

const imgStyle = {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%"
}

const styleHeader = { 
    backgroundColor: "#343a40",
    color: "white"
}

export default PostSummary;
